import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pasport',
  templateUrl: './pasport.component.html',
  styleUrls: ['./pasport.component.scss']
})
export class PasportComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
